module.exports = __webpack_public_path__ + "static/media/photo39.5b5b1a54.jpg";